import { DatePipe } from '@angular/common';
import { Component,HostListener, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { ImageuploadService } from '../../Imageupload.service';
import { LoginService } from '../../login-service';

@Component({
    selector: 'collabo-app',
    templateUrl: 'collabo.component.html'
})

export class CollaboComponent implements OnInit {
  paytype:any
  paytype1:any;
  loc:any;
  actor:any;
  collabo:any;
  startdatesearch: any;
  enddatesearch:any
  datesearch: any;
  showclearsearch:boolean=false;
  showadvance:boolean=false;
    masterSelected:boolean;
    masterSelected1:boolean;
    filteredservicecharge:any;
    panelOpenState = false;
    displayfiles:boolean=false;
    actorSelected = [];
  checklist: Array<{id:number,value: string, isSelected: boolean}> = [];
  checkedList:any;
searchText:string;
CheckedActorID:any;
actordescription:any;
    selectedActorsList:any;
    selectedSkillsListid:any=[];
    selectedSkillsListname:any=[];
    selectedSkillsList:any=[];
    selectedSkillsListid1:any;
    IsBid:boolean=false;
    dragAreaClass: string;
    showPraposalDetails=[];
    tempPraposalDetails:any;
    IsTotalAmout:boolean=false;
    lblTotalAmout:number;
    statusID:string;
    collaboID:string;
    [x: string]: any;
    tabtype:string;
    PraposalActors=[];
    selectedAll=[];
tabName:string;
PraposalDescription:string;
    openCollobo:boolean=true;
    onGoCollobo:boolean=false;
    savedCollobo:boolean=false;
    
    closedcollobo:boolean=false
    collaboList:any;
    tempCol=[];
    Actorid: string;
    ActorpercentageId:string;
    skilsList: any;
    tabSelection:string;
    collabosByStatusList=[];
    StatusList:any;
    Accordian: any;
    IsCollabo:boolean=false;
  displayinput:boolean=false;
    RowCollaboDetils:any;
    servicechargeList:any;
    servicechargeListDetails:any;
    IsPraposal:boolean=false;
    CollaboPraposalDetails:any;
    collaboCheck:boolean=false;
    bidRowID: any;
   selectedgroups  = [];
    displayattach:boolean=false;
userID:string;
    //SavePraposal Details
    BidAmout:string
    ServiceCharge:any;
    toalHours:string;
    hoursEstimated:string;
    onSelectCheckBox = false;
    //checkbox
    checknamelist=[]; 
    selected:string;
    userType:string;
    name:string;
    presentCollabos:any;
    selectedcolor:boolean=false;
    changeColor= [false, false, false,false,false,false];
     count=0;
     c: any;
     expandedIndex = 0;
     private isCollapsed: boolean = true;
collabosposted:any;
tempactor:any=[];
filenameWithExtension:any;

    constructor(private loginService:LoginService,public imageservice: ImageuploadService,public datepipe: DatePipe) {
      this.userType=localStorage.getItem("userType");
      this.isCollapsed = false;
      }



public collapsed(event: any): void {
}

public expanded(event: any): void {
}

    ngOnInit() {  this.tabSelection='open';
    this.userID=localStorage.getItem('USERID');
    this.IsCollabo=true;
    this.tabChange(this.tabSelection);
    this.GetStatus(); 
    //  this.GetCollabos();
    this.tabtype="step1";
    this.masterSelected = false;
    this.dragAreaClass = "dragarea";
    this.GetServicecharge();
   
    }
    GetServicecharge(){
      
      this.loginService.Getservicecharge(3).subscribe(data=>
        {
          data = JSON.parse(data['_body']);
          this.servicechargeList = data;
        });
     
   } 
    ChangeUnitSubGrp(element, event, i,row) {
       this.selectedSkillsListid=[];
       if(this.servicechargeList.length>0)
       {
       this.filteredservicecharge=this.servicechargeList.filter(x=>(parseInt(x.Frombudget)<=parseInt(row.estimated_time))&&(parseInt(x.Tobudget)>=parseInt(row.estimated_time)))
        if(this.filteredservicecharge.length>0){
       this.ServiceCharge=this.filteredservicecharge[0].Servicecharge
        }
        else{
          this.ServiceCharge=0
        }
       }
       else{
        this.ServiceCharge=0
       }
          element.check = event.checked;
          this.RowCollaboDetils=row;
          if (!event.checked) {
            this.checkAll = false;
            const index = this.selectedgroups.indexOf(element);
            this.selectedgroups.splice(index, 1);
            this.checkEnable = false;
          } else {
            this.selectedgroups.push(element);
            this.checkEnable = true;
          }
          if (this.selectedgroups.length === 0) {
            this.checkEnable = false;
          }
              for(let i=0;i<this.selectedgroups.length;i++)
            {
               this.selectedSkillsListid=this.selectedgroups[i].ActorId;
              this.CheckedActorID=element.ActorId;
                this.actorSelected[i]=event.checked;
            }
        }
        filteraccdates()
        {
          console.log(this.startdatesearch,this.enddatesearch)
          console.log(this.statusCollabos)
          this.statusCollabos=this.statusCollabos.filter(x=>(x.createddate<=this.enddatesearch)&&(x.createddate>=this.startdatesearch))
          if(this.statusCollabos.length>0)
          {
            this.showclearsearch=true;
          }
          console.log(this.statusCollabos)
        }
        searchadvanced()
        {
          console.log(this.statusCollabos,this.paytype1)
          if((this.loc==undefined)&&(this.actor==undefined)&&(this.skills==undefined)&&(this.collabo==undefined)&&(this.datesearch==undefined)&&this.paytype1==undefined)
          {
            return;
          }
          this.showclearsearch=true;
  if(this.loc==undefined){this.loc=""}
  if(this.actor==undefined){this.actor=""}
  if(this.skills==undefined){this.skills=""}
  if(this.collabo==undefined){this.collabo=""}
  if(this.datesearch==undefined){this.datesearch=""}
  if(this.paytype1==undefined){this.paytype=""}
  this.statusCollabos=[];
  this.statusCollabos=this.presentCollabos;
  this.tempcollabos = this.statusCollabos;
  if(this.paytype1=="1"){this.paytype="hour"}
  else if(this.paytype1=="2"){this.paytype="price"}
  else if(this.paytype1=="3"){this.paytype="percent"}
   let tempCompany = this.statusCollabos.filter(
     (item) => {
       console.log(item.pay_type)
      for(var i=0;i<item.ActorID.length;i++){
       return (
         (item.title !== null && item.title.toLowerCase().indexOf(this.collabo.toLowerCase().trim()) > -1)&&(item.region !== null && item.region.toLowerCase().indexOf(this.loc.toLowerCase().trim()) > -1)&&(item.skillname !== null && item.skillname.toLowerCase().indexOf(this.skills.toLowerCase().trim()) > -1) &&(item.ActorID[i].name !== null && item.ActorID[i].name.toLowerCase().indexOf(this.actor.toLowerCase().trim()) > -1)&&(item.createddate.split("T")[0] !== null && item.createddate.split("T")[0].indexOf(this.datesearch.trim()) > -1)&&(item.pay_type !== null && item.pay_type.toLowerCase().indexOf(this.paytype.toLowerCase().trim()) > -1)
       );
      }
     }
  
   );
   this.statusCollabos = tempCompany;
        }
cancel()
{
  this.showadvance=false;
  this.loc="";
  this.actor="";
  this.skills="";
  this.collabo="";
  this.startdatesearch="";
  this.enddatesearch="";
}
        cancelsearch()
        {
          this.showclearsearch=false;
          this.showadvance=false;
          this.statusCollabos=this.presentCollabos;
          this.loc="";
          this.actor="";
          this.skills="";
          this.collabo="";
          this.startdatesearch="";
          this.enddatesearch="";
        }

    CheckAll(event) {
      // this.ccservice.currentUserName = this.userName;
      this.selectedgroups = [];
    if (event.checked) {
      this.checkEnable = true;
    } else {
      this.checkEnable = false;
       this.checkAll = false;
    }
    
      for (let i = 0; i < this.CollaboPraposalDetails.ActorID.length; i++) {
       // this.ChangeUnitSubGrp(this.CollaboPraposalDetails.ActorID[i], event, i);
        this.checklist1[i] = event.checked;
        this.actorSelected[i]=event.checked;
      }
    
    }
    

    opencollabo(item){
      this.c=item;
      console.log(item)
      this.RowCollaboDetils=item;
    }
    checkUncheckAll() {
        for (var i = 0; i < this.checklist.length; i++) {
          this.checklist[i].isSelected = this.masterSelected;
        }
        this.getCheckedItemList();
      }
      isAllSelected() {
        this.masterSelected = this.checklist.every(function(item:any) {
            return item.isSelected == true;
          })
        this.getCheckedItemList();
      }
    
      getCheckedItemList(){
        this.checkedList = [];
        for (var i = 0; i < this.checklist.length; i++) {
          if(this.checklist[i].isSelected)
          this.checkedList.push(this.checklist[i]);
        }
        this.checkedList = JSON.stringify(this.checkedList);
      
      }
    

    calculateTotalAmount(){
        if(this.BidAmout !== undefined && this.ServiceCharge!==undefined){
            this.lblTotalAmout = parseInt(this.BidAmout)-(parseInt(this.BidAmout)*parseInt(this.ServiceCharge)/100);
            this.IsTotalAmout=true;
          }
    }
    
    CollaboDetails(row){
        this.IsCollabo=false;
        this.RowCollaboDetils=row;
        console.log(row)
       if(((this.RowCollaboDetils.CollaboDocumentPath!=null)||(this.RowCollaboDetils.CollaboDocumentPath!=''))&&((this.RowCollaboDetils.LegalDocumentPath!=null)||(this.RowCollaboDetils.LegalDocumentPath!='')))
       {
         this.displayattach=true;
       }
       else{
         this.displayattach=false;
       }
        if(this.RowCollaboDetils.collabofilename==""||this.RowCollaboDetils.legaldocumentpathname=="")
        {
          this.displayfiles=true;
        }
        else{
          this.displayfiles=false;
        }
        this.statusID=row.status;

        this.loginService.GetUsers(1).subscribe(data=>
          {
            
            data = JSON.parse(data['_body']);
                  this.usersList=JSON.parse(JSON.stringify(data));
                
         let validateUser=this.usersList.filter(x=>x.id===this.RowCollaboDetils.initiatoruserid);
        var collabos;
         this.username=validateUser[0].user_name;
         collabos=this.tempCollaboList.filter(x=>x.userid==this.RowCollaboDetils.initiatoruserid);
         this.collabosposted=collabos.length;
         if(validateUser[0].Profile!=null)
         {
          this.url=this.loginService.imageURL;
           this.profile1=validateUser[0].Profile
         }
         else{
          this.url="";
          this.profile1='../../assets/images/user.png';
         }
    
          })
          this.loginService.GetLegalDocuments().subscribe(data=>
            {  
              data = JSON.parse(data['_body']);
              this.documentsList =  JSON.parse(JSON.stringify(data));
            
              this.filtereddocList=this.documentsList.filter(x=>x.userid.toString()===this.userID.toString());
              
            });
            if(((this.RowCollaboDetils.legaldocumentpathname=="")||(this.RowCollaboDetils.legaldocumentpathname==null))&&((this.RowCollaboDetils.collabofilename==null)||(this.RowCollaboDetils.collabofilename=="")))
            {
              this.displayattach=false;
            }
            else
            {
              this.displayattach=true;
            }




            this.PraposalActors=[];
            
    let filterPraposals=this.tempPraposaBids.filter(x=>x.collaboid==row.id && x.userid.toString()==this.userID.toString());
    let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===row.id);
    if(CollaboActors.length>0)
    {
      this.ColaboActorDetails=CollaboActors;
    }

    
    else{
      this.ColaboActorDetails=[];
    }
    if(filterPraposals.length>0)
    {
      for(let i =0;i<filterPraposals.length;i++){
      filterPraposals[i]['actorids'].split(',').forEach(element1 => {
      let filterActor= this.ColaboActorDetails.filter(x=>x.ActorId.toString()===element1.toString()  )
      if(filterActor.length>0)
    this.PraposalActors.push({
      RowID:filterActor[0].RowID,
      ActorId:filterActor[0].ActorId,
      name:filterActor[0].name,
      CollaboId:filterActor[0].CollaboId,
      NoOfActors:filterActor[0].NoOfActors,
      Percentage:filterActor[0].Percentage,
      Fees:filterActor[0].Fees
    });
    
    });
  }
  }
    }
    CancelPraposal(){
      
        this.IsPraposal=false;
        this.IsCollabo=true;
        this.collaboCheck=false;
        this.PraposalDescription="";
        this.masterSelected=false;
        this.BidAmout="";
        this.ServiceCharge="";
        this.toalHours="";
        this.hoursEstimated="";
    }
    BackToCollabo(){
        this.IsCollabo=true;
        this.collaboCheck=false;
        this.tabtype='sh';
        this.GetCollabos();

    }
    getvalues(){

    }


@HostListener("dragover", ["$event"]) onDragOver(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragend", ["$event"]) onDragEnd(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("drop", ["$event"]) onDrop(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
  event.stopPropagation();
  if (event.dataTransfer.files) {
    this.displayinput=true;
    let files: FileList = event.dataTransfer.files;
    
    this.filename=files[0].name
   
     if(files[0].type=="application/pdf"||"application/doc")
     {
    this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,"submitproposal");
   
    this.imageservice.ImageUplode1.subscribe( );
    this.proposalfilepath='Images/submitproposal/'+this.userID+'/'+this.filename
    
    localStorage.setItem('proposalfilepath',this.proposalfilepath);
     }
     else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
     {
      this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,"submitproposal");
      
      this.imageservice.ImageUplode.subscribe();
      this.proposalfilepath='Images/submitproposal/'+this.userID+'/'+this.filename
  
  localStorage.setItem('proposalfilepath',this.proposalfilepath);
      
     }
  }
}
view(doc)
{
  window.open(this.loginService.imageURL+doc);
}
fileChange(input) {
  console.log(input.files)
  this.displayinput=true;
  this.filename=input.files[0].name
  
  this.imagefile = this.loginService.filechange1(input,"submitproposal",this.userID);
  
  this.imageservice.ImageUplode1.subscribe();
  this.proposalfilepath='Images/submitproposal/'+this.userID+'/'+this.filename
  
  localStorage.setItem('proposalfilepath',this.proposalfilepath);
  
}

closefile()
{
  this.displayinput=false;
}
    colours(actorsList)
    {
      //  this.count=this.count+1; 
      //   if((this.count)%2==0)
      //   {
      //     this.selectedSkillsListid=[];
      //       this.changeColor= [false, false, false,false,false,false];
      //   }
      //   else
      //   {
      //       this.changeColor= [true, true, true,true,true,true];
      //       for(let i=0;i<actorsList.length;i++)
      //       {
      //         this.selectedSkillsListid.push(actorsList[i].ActorId);
      //       }
      //   }
       
    }
   
    SelectedActors(actor){
        
        var count=this.selectedSkillsListid.length;
        
 // if(this.selectedSkillsListid.includes(actor))
        // {
           
         //}
//else{
             //this.selectedSkillsListid.push(actor);
         //}

       
    }

    deleteProposal(row){
        event.stopPropagation();
        Swal.fire({
          title: 'Are you sure?',
          text: 'You want to delete this Bid Proposal' ,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value) {
            this.delete(row.rowid,'n');
          } else if (result.dismiss === Swal.DismissReason.cancel) {
      
          }
        })
      
      }
      
      delete(ID,isactive) {
        const json={
          rowid:ID,
          isactive:isactive
        }
        this.loginService.DeleteProposalbid(json).subscribe(data => {
       
        this.loginService.showSuccess("Deleted Successfully","");
      this.BackToCollabo();
          // this.GetCollabos();
          setTimeout(() => {
            this.message = "";
          }, 1000);
        // this.getFares();
        // this.setPage(1);
        })
      }
    

    editProposal(row,tabType)
    {
      this.tabtype=tabType;
      this.ttype='edit';
      this.IsPraposal=true;
      this.IsCollabo=false;
      this.collaboCheck=true;
      this.CollaboPraposalDetails=row;
      this.filename=row.proposalfilepath.replace(/^.*[\\\/]/, '');
      this.bidRowID=row.rowid;
      this.PraposalDescription=row.description;
      this.BidAmout=row.amount;
      this.ServiceCharge=row.servicecharge_percent;
      this.toalHours=row.totalhours;
      this.hoursEstimated=row.hoursestimated;
      this.CheckedActorID=row.actorid;
      this.collaboID=row.collaboid
    }


    SavePraposal(collaboId){
this.submitproposalfile=localStorage.getItem('proposalfilepath')
if(this.ttype=='new'){
       this.collaboID=collaboId;
}
let serivechargeamount=(parseInt(this.BidAmout)*parseInt(this.ServiceCharge)/100)
const json={
    bidRowID:this.bidRowID,
    colaboId:this.collaboID,
    userid:this.userID,
    description:this.PraposalDescription,
    bidsAmout:this.BidAmout,
    serviceCharge:this.ServiceCharge,
    serviceChargeamount:serivechargeamount,
    toalHours:this.toalHours,
    hoursEstimated:this.hoursEstimated,
    createdbyparm:'Admin',
    updatedbyparm:'Admin',
    proposalfilepath:this.submitproposalfile,
    ActorID:this.CheckedActorID,
statusparm:"2",
bidstatus:'InProgress'  ,
actorid:this.CheckedActorID  
}
console.log(json)
this.loginService.SavePraposalBids(json).subscribe(data=>{
  console.log(data)
 this.UpdateStatus(collaboId,2);
 this.loginService.showSuccess("Bidding Succesfull","");
 localStorage.removeItem('proposalfilepath')
 this.sendNotifications();
 this.BackToCollabo();
 this.PraposalDescription="";
 this.masterSelected=false;
 this.BidAmout="";
 this.ServiceCharge="";
 this.toalHours="";
 this.hoursEstimated="";
})
    }
    sendNotifications(){
      var bidcollabo=this.tempCollaboList.filter(x=>x.id==this.collaboID);
      const json={
        id:0,
      name:'New Bid',
      description:'New Bid for '+bidcollabo[0].title +' collabo',
      userid:this.userID,
      receiveruserid:bidcollabo[0].userid,
      type:'Bid',
      typeid:0,
      createdby:'Admin',
      updatedby:'Admin',
      IsSender:0
      }
     
      this.loginService.SaveNotifications(json).subscribe(data=>{
      });
    }
    CancelCollabo(){
        this.IsCollabo=true;
        this.IsPraposal=false;
        this.collaboCheck=false;
        this.PraposalDescription="";
        this.masterSelected=false;
        this.BidAmout="";
        this.ServiceCharge="";
        this.toalHours="";
        this.hoursEstimated="";

    }
    nextPrev(tabname)
    {
this.tabName=tabname;
this.tabtype=tabname;
    }
    openCol(){

        this.openCollobo=true;
        this.onGoCollobo=false;
        this.savedCollobo=false;
        
        this.closedcollobo=false;
    }
GetStatus(){
this.loginService.GetStatus().subscribe(data=>
    {
        data = JSON.parse(data['_body']);
        this.StatusList=JSON.parse(JSON.stringify(data));

    });
}

hover(user)
{
  this.actordescription=user.description;
}

    tabChange(tabType)
    {
this.tabSelection=tabType;
this.GetCollabos();
    }
    
    GetCollabos(){
        this.statusCollabos=[];
        this.tempCollaboList=[];
        this.tempColaboActorDetails=[];
        this.tempPraposaBids=[];
        this.collaboList=[];
        this.tempCol=[];
       
        this.loginService.GetCollabos(this.userType).subscribe(data=>
            {
                data = JSON.parse(data['_body']);
                this.tempCollaboList=JSON.parse(JSON.stringify(data));
               var bidcollabo=this.tempCollaboList.filter(x=>x.id==136);
              this.loginService.GetCollaboActorDetails().subscribe(data1=>{

             data1=JSON.parse(data1["_body"]);
             this.tempColaboActorDetails=JSON.parse(JSON.stringify(data1));
                 this.loginService.GetPraposalBids().subscribe(data=>
                  {
                       data = JSON.parse(data['_body']);
                      this.tempPraposaBids=JSON.parse(JSON.stringify(data));
            
               var collabolist=this.tempCollaboList.filter(x=> x.parentcollaboid==0);
                    this.collaboList=collabolist;
                    var temp=this.tempCollaboList.filter(x=> x.parentcollaboid!=0);
this.tempSubcollaboList=temp;

               if(this.collaboList.length>0)
          
for(let i=0;i<this.collaboList.length;i++)
{ 
  this.CollaboPraposalDetails=[];

let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===this.collaboList[i].id);

if(CollaboActors.length>0)
{
  this.ColaboActorDetails=CollaboActors;
}
else{
  this.ColaboActorDetails=[];
}

  let tempSubCollabos=this.tempSubcollaboList.filter(x=>x.parentcollaboid===this.collaboList[i].id);
if(tempSubCollabos.length>0)
{
  this.IsSubCollabo=true;
}
else{
  this.IsSubCollabo=false;
}
   this.CollaboPraposalDetails=this.tempPraposaBids.filter(x=>x.collaboid.toString()==this.collaboList[i].id.toString() && x.userid==this.userID);
   var collabobids=this.tempPraposaBids.filter(x=>x.collaboid.toString()==this.collaboList[i].id.toString());
   var hiredbids=this.tempPraposaBids.filter(x=>x.collaboid.toString()==this.collaboList[i].id.toString() && x.bidstatus=="Accepted");
   if(this.CollaboPraposalDetails.length>0)
  {
    //  this.IsBid=true;

   
    var bidsArray=[];
    this.ColaboActorDetails.forEach((element)=>{
    var filterPraposals=this.CollaboPraposalDetails.filter(x=>x.actorid==element.ActorId);
    console.log(filterPraposals);
    if(filterPraposals.length>0){
      element.isBid=true;
    
    }
else {element.isBid=false;}
      
     
  });
  console.log(this.ColaboActorDetails);


  
  if(!this.collaboList[i].ActorID)
  {this.Actorid="";}
  else
{ this. Actorid= JSON.parse(this.collaboList[i].ActorID)
}

 if(!this.collaboList[i].ActorPercentageID)
 {this.ActorpercentageId="";
}
 else
{this. ActorpercentageId= JSON.parse(this.collaboList[i].ActorPercentageID)}

  }
    this.tempCol.push({
        id:this.collaboList[i].id,
        category_id:this.collaboList[i].category_id,
        category: this.collaboList[i].category,
        sub_category_id: this.collaboList[i].sub_category_id,
        category1: this.collaboList[i].category1,
        name: this.collaboList[i].name,
        expected_budget: this.collaboList[i].expected_budget,
        estimated_time: this.collaboList[i].estimated_time,
        pay_type:this.collaboList[i].pay_type,
        status: this.collaboList[i].status,
        start_date:this.collaboList[i].start_date,
        end_date: this.collaboList[i].end_date,
        region: this.collaboList[i].region,
        SkillID: this.collaboList[i].SkillID,
        initiatoruserid:this.collaboList[i].userid,
        CollaboDocumentPath: this.collaboList[i].CollaboDocumentPath,
        ProjectPeriod: this.collaboList[i].ProjectPeriod,
        SpecificTimeline: this.collaboList[i].SpecificTimeline,
        collabofilename:this.collaboList[i].collabofilename,
        legaldocumentpathname:this.collaboList[i].legaldocfilename,
        //ActorID:this.Actorid ,
        ActorID:this.ColaboActorDetails,
        actorname: this.collaboList[i].actorname,
        PayValue: this.collaboList[i].PayValue,
        LegalDocumentPath: this.collaboList[i].LegalDocumentPath,
        createdby: this.collaboList[i].createdby,
        description: this.collaboList[i].description,
        skillname:this.collaboList[i].skillname,
        createddate:this.collaboList[i].createddate.split("T")[0],
        ActorPercentageID:this.ActorpercentageId,
        title:this.collaboList[i].title,
        statusname:this.collaboList[i].statusname,
        // Bids:this.collaboList[i].Bids,
        SubCollabo:this.IsSubCollabo,
        SubCollaboList:tempSubCollabos,
        Bid:this.IsBid,
        Noofbids:collabobids.length,
        Hired:hiredbids.length,
       bidDetails:this.CollaboPraposalDetails
    }
    
    )
    this.statusChange(1);
}
            
                     })
                    })
                    });

                    

                    
    }
    ShowPraposal(row,tabtype,actorid)
    {
      this.PraposalActors=[];
        this.showPraposalDetails=[];
        this.RowCollaboDetils=[];
    this.tabtype='show';
    this.RowCollaboDetils=row;

    this.IsCollabo=true;
    this.collaboCheck=false;


    let filterPraposals=this.tempPraposaBids.filter(x=>x.collaboid==row.id && x.userid.toString()==this.userID.toString()&& x.actorid==actorid);
    
let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===row.id && x.ActorId==actorid);
if(CollaboActors.length>0)
{
  this.ColaboActorDetails=CollaboActors;
}
else{
  this.ColaboActorDetails=[];
}
console.log(filterPraposals)
 for(let i=0;i<filterPraposals.length;i++){
  this.showPraposalDetails.push({  
       collabodetails:row,
            bidsDetails:filterPraposals[i],
             TotalBidAmout:parseInt(filterPraposals[i].amount)-(parseInt(filterPraposals[i].amount)*parseInt(filterPraposals[i].servicecharge_percent)/100),
             servicecharge:filterPraposals[i].servicecharge_amount,
 praposalActors:this.ColaboActorDetails
    })   

  }
    this.filenameWithExtension = filterPraposals[0].proposalfilepath.replace(/^.*[\\\/]/, '');
    }
    UpdateStatus(row,status){
       
        const json={
        idparam:row,
        updatedbyparam:'admin',
        statusparam:status
        }
       
        this.loginService.UpdateCollaboStatus(json).subscribe(data=>{
            setTimeout(() => {
                this.GetCollabos();
            }, 2000);
           
        })
    }
    statusChange(id){
        this.statusID=id;
        
          this.statusCollabos=this.tempCol.filter(x=>x.status===id);
       
        this.presentCollabos=this.statusCollabos;
        this.c=this.statusCollabos[0];
     
      }

    
    DisplaysubCollabos(id,list){
        this.ColaboActorDetails=[];
       this.subcollaboList=[];
           this.subCollabos=true;
     
          // for(var i=0;i<this.tempSubcollaboList.length;i++){
          
            var sub=this.tempSubcollaboList.filter(x=>x.parentcollaboid===id);
  
            
  for(let i=0;i<sub.length;i++)
  {
    
  let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===sub[i].id);
    if(CollaboActors.length>0)
    {
      this.ColaboActorDetails=CollaboActors;
    }
    else{
      this.ColaboActorDetails=[];
    }
    
  
            this.subcollaboList.push({
              id:sub[i].id,
              category_id:sub[i].category_id,
              category: sub[i].category,
              sub_category_id: sub[i].sub_category_id,
              category1: sub[i].category1,
              name: sub[i].name,
              expected_budget: sub[i].expected_budget,
              estimated_time: sub[i].estimated_time,
              pay_type:sub[i].pay_type,
              status: sub[i].status,
              start_date:sub[i].start_date,
              end_date: sub[i].end_date,
              region: sub[i].region,
              SkillID: sub[i].SkillID,
              CollaboDocumentPath: sub[i].CollaboDocumentPath,
              ProjectPeriod: sub[i].ProjectPeriod,
              SpecificTimeline: sub[i].SpecificTimeline,
              //ActorID:this.Actorid ,
              ActorID:this.ColaboActorDetails,
              actorname: sub[i].actorname,
              PayValue: sub[i].PayValue,
              LegalDocumentPath: sub[i].LegalDocumentPath,
              createdby: sub[i].createdby,
              description: sub[i].description,
              parentcollaboid:sub[i].parentcollaboid,
              skillname:sub[i].skillname,
              createddate:sub[i].createddate.split("T")[0],
              ActorPercentageID:this.ActorpercentageId,
              title:sub[i].title,
              statusname:sub[i].statusname,
              // Bids:this.collaboList[i].Bids,
              SubCollabo:this.IsSubCollabo,
             // SubCollaboList:tempSubCollabos
          }
  
  
            )
          
        }
           // this.subcollaboList=sub;
  
  
  
         
         // }
        
        
      }
      hideSubcollabos(){
        this.subCollabos=false;
      }

    GetSkills(){
        this.loginService.Getskills(this.userType).subscribe(data=>{
           data = JSON.parse(data['_body']);
           this.skilsList=JSON.parse(JSON.stringify(data));
           
        })
    }
    onGoingCol(){
      
        this.openCollobo=false;
        this.onGoCollobo=true;
        this.savedCollobo=false;
        this.closedcollobo=false;
    }
    savedCol()
    {

        this.openCollobo=false;
        this.onGoCollobo=false;
        this.savedCollobo=true;
        this.closedcollobo=false;
    }
    closedCol(){

        this.openCollobo=false;
        this.onGoCollobo=false;
        this.savedCollobo=false;
        this.closedcollobo=true;
    }
    calculateDiff(sentDate,enddate) {
        var date1:any = new Date(sentDate);
        var date2:any = new Date(enddate);
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    
        return diffDays;
    }

   
    SubmitPraposal(row,tabType,actorid){
        this.tabtype=tabType;
this.IsPraposal=true;
this.ttype='new';
this.IsCollabo=false;
this.collaboCheck=true;
this.CollaboPraposalDetails=row;
this.CheckedActorID=actorid
this.PraposalActors=[];
let filterPraposals=this.tempPraposaBids.filter(x=>x.collaboid==row.id && x.userid.toString()==this.userID.toString());
    
let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===row.id && x.ActorId==actorid);

if(CollaboActors.length>0)
{
  this.ColaboActorDetails=CollaboActors;
}
else{
  this.ColaboActorDetails=[];
}
this.PraposalActors.push(this.ColaboActorDetails);


    }
    Searchtext(){
      this.statusCollabos=[];
      this.statusCollabos=this.presentCollabos;
    
     let tempCompany = this.statusCollabos.filter(
       (item) => {
         return (
           (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
         );
       }
    
     );
     this.statusCollabos = tempCompany;
    
    }
    accordianValue(value)
    {
      this.Accordian=value;
    }
}
